import React from "react";
import { Alert, Badge, Button, Col, Container, Row, Table } from "reactstrap";

export default function BootstrapDemo() {
	return (
		<>
			<Container>
				<h1>Fonts</h1>
				<div>
					<p>This is default font.</p>
					<p class='semi-bold'>This is semibold font.</p>
				</div>
			</Container>
			<Container>
				<h1>Buttons</h1>
				<div>
					<Button color="primary">primary</Button> 
                    <Button color="secondary">secondary</Button>{" "}
					<Button color="success">success</Button>{" "}
					<Button color="info">info</Button>{" "}
					<Button color="light">light</Button>{" "}
					<Button color="warning">warning</Button>{" "}
					<Button color="danger">danger</Button>{" "}
					<Button color="link">link</Button>
					<Button color="accent">accent</Button>
				</div>
			</Container>
			<Container>
				<h1>Alerts</h1>
				<Alert color="primary">This is a primary alert — check it out!</Alert>
				<Alert color="secondary">This is a secondary alert — check it out!</Alert>
				<Alert>This is a default alert — check it out!</Alert>
				<Alert color="danger">This is a danger alert — check it out!</Alert>
				<Alert color="warning">This is a warning alert — check it out!</Alert>
				<Alert color="info">This is a info alert — check it out!</Alert>
				<Alert color="light">This is a light alert — check it out!</Alert>
				<Alert color="dark">This is a dark alert — check it out!</Alert>
				<Alert color="accent">This is a accent alert — check it out!</Alert>
			</Container>
			<Container>
				<h1>Backgrounds</h1>
				<div>
					<div class="bg-primary text-white">Im a primary background.</div>
					<div class="bg-secondary text-white">Im a secondary background.</div>
					<div class="bg-success text-white">Im a success background.</div>
					<div class="bg-danger text-white">Im a danger background.</div>
					<div class="bg-warning text-white">Im a warning background.</div>
					<div class="bg-info">Im a info background.</div>
					<div class="bg-light">Im a light background.</div>
					<div class="bg-dark text-white">Im a dark background.</div>
					<div class="bg-accent accent text-white">Im a accent background.</div>
				</div>
			</Container>
		</>
	);
}
